import { render, staticRenderFns } from "./LastThreeArticles.vue?vue&type=template&id=7442ba0f&scoped=true&"
import script from "./LastThreeArticles.vue?vue&type=script&lang=js&"
export * from "./LastThreeArticles.vue?vue&type=script&lang=js&"
import style0 from "./LastThreeArticles.vue?vue&type=style&index=0&id=7442ba0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7442ba0f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardTitle,VCol,VImg,VRow,VSpacer})
